import LoginChoice from './LoginChoice';

export default LoginChoice;
